import Footer from "../components/footer";
import Login from "../components/login";
import Navbar from "../components/navbar";
import Register from "../components/register";

function RegisterPage() {
  return (
    <>
      <div className="max-w-screen-xl  mx-auto pt-20 flex-col bg-fixed">
        <Navbar />
        <Register />
        <Footer />
      </div>
    </>
  );
}
export default RegisterPage;
